import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export default function ProtectedRoute({ children, requireAdmin = false, requireBilling = false, allowBilling = false, allowedRoles = null }) {
    const { user, loading, isAdmin, isBillingOnly, isBilling } = useAuth();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#F9FAFB]">
                <div className="text-center">
                    <Loader2 className="w-8 h-8 animate-spin text-[#002FA7] mx-auto" />
                    <p className="mt-4 text-[#4B5563]">Chargement...</p>
                </div>
            </div>
        );
    }

    if (!user || user === false) {
        return <Navigate to="/login" replace />;
    }

    // Generic role whitelist (e.g. audit page allows admin/manager/billing_admin)
    if (allowedRoles && !allowedRoles.includes(user.role)) {
        return <Navigate to={isBillingOnly ? '/dashboard/settings/subscription' : '/dashboard'} replace />;
    }

    // Admin-only pages: deny everyone but admin (billing_admin included)
    if (requireAdmin && !isAdmin) {
        return <Navigate to={isBillingOnly ? '/dashboard/settings/subscription' : '/dashboard'} replace />;
    }

    // Billing-only pages: only roles with billing access can enter
    if (requireBilling && !isBilling) {
        return <Navigate to="/dashboard" replace />;
    }

    // billing_admin shouldn't access pages outside their scope (jobs, candidates, analytics, trash, dashboard home)
    if (isBillingOnly && !allowBilling && !(allowedRoles || []).includes('billing_admin')) {
        return <Navigate to="/dashboard/settings/subscription" replace />;
    }

    return children;
}
